import Vue from 'vue'

import Qs from 'qs'

class Admins {
  async index({params}) {
    return await Vue.axios
      .get('app/admins', {
        params,
        paramsSerializer: (params) => {
          return Qs.stringify(params)
        }
      })
  }

  async create({data}) {
    return await Vue.axios
      .post('app/admins', data)
  }

  async read({id}) {
    return await Vue.axios
      .get('app/admins/' + id)
  }

  async update({id, data}) {
    return await Vue.axios
      .put('app/admins/' + id, data)
  }

  async delete({id}) {
    return await Vue.axios
      .delete('app/admins/' + id)
  }
}

const admins = new Admins()

export default admins
